import { render, staticRenderFns } from "./AccountPlan.vue?vue&type=template&id=a247d5ba&scoped=true&"
import script from "./AccountPlan.vue?vue&type=script&lang=js&"
export * from "./AccountPlan.vue?vue&type=script&lang=js&"
import style0 from "./AccountPlan.vue?vue&type=style&index=0&id=a247d5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a247d5ba",
  null
  
)

export default component.exports